module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/af40e1882a7506b7830318c482d708e5.png";